import { DefaultValues } from 'react-hook-form';

import { DataGridColSettings } from '@/components/DataGrid/utils';
import { IUnitForm } from '@/models';

export const unitDataGridCols: DataGridColSettings[] = [
  {
    field: 'name',
    headerName: 'Unit name',
    visible: true,
  },
  {
    field: 'type',
    headerName: 'Unit type',
    width: 340,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Unit status',
    width: 340,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
type IUnitManagementTab = {
  path: string;
  label: string;
};

export const UnitManagementTabs: Record<string, IUnitManagementTab> = {
  units: {
    path: 'units',
    label: 'Units',
  },
  types: {
    path: 'types',
    label: 'Types',
  },
  assignments: {
    path: 'assignments',
    label: 'Assignments',
  },
  history: {
    path: 'history',
    label: 'Shift History',
  },
};

export const UnitFormFields = {
  title: 'Unit information',
  items: [
    {
      name: 'name',
      type: 'text',
      label: 'Unit name',
      rules: {
        required: 'This field is required.',
        minLength: {
          value: 3,
          message: 'Name should be more than 3 characters long.',
        },
      },
    },
    {
      name: 'type',
      type: 'autocomplete',
      label: 'Unit type',
      rules: {
        required: 'This field is required.',
      },
    },
  ],
};

export const NERISUnitViewFields = {
  title: 'NERIS Unit information',
  items: [
    {
      name: 'neris.unitNerisId',
      type: 'text',
      label: 'NERIS Unit ID',
    },
    {
      name: 'neris.unitNerisType',
      type: 'select',
      label: 'NERIS Unit Type',
    },
    {
      name: 'neris.useInIncidents',
      type: 'checkbox',
      label: 'Used in NERIS incident reports',
    },
  ],
};

export const StandByCheckBox = {
  name: 'isStandByWhenOffDuty',
  type: 'checkbox',
  label: 'Standby when off duty',
};

export const UnitDefaultValues: DefaultValues<IUnitForm> = {
  name: '',
  type: '',
  isStandByWhenOffDuty: false,
  unitNerisType: '',
  unitNerisId: '',
  usedInIncidents: false,
  autoCreateAndAssignNerisUnit: false,
  stuffing: 0,
} as const;

export const NERISCheckBox = {
  name: 'registerInNeris',
  type: 'checkbox',
  label: 'Register in NERIS',
};
